import { render, staticRenderFns } from "./QueryRoleUseDetailsEditComponent.vue?vue&type=template&id=642b39e6"
import script from "./QueryRoleUseDetailsEditComponent.vue?vue&type=script&lang=js"
export * from "./QueryRoleUseDetailsEditComponent.vue?vue&type=script&lang=js"
import style0 from "./QueryRoleUseDetailsEditComponent.vue?vue&type=style&index=0&id=642b39e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports